import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

export class MainVersionsAlerts extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    const hash = '#'
    const {
      intl,
      show,
      textId,
      isTextSmall = false,
      textIdSmall,
      params = {},
    } = this.props

    return (
      <div className={show ? 'bb-history__alert active' : 'bb-history__alert'}>
        <figure>
          <svg
            width={138}
            height={138}
            viewBox="0 0 138 138"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M72.4001 83.9996C72.4001 85.8774 70.8779 87.3996 69.0001 87.3996C67.1223 87.3996 65.6001 85.8774 65.6001 83.9996C65.6001 82.1218 67.1223 80.5996 69.0001 80.5996C70.8779 80.5996 72.4001 82.1218 72.4001 83.9996Z"
              fill="#0096D6"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M69.0001 46.5996C70.8779 46.5996 72.4001 48.1219 72.4001 49.9996V70.3996C72.4001 72.2774 70.8779 73.7996 69.0001 73.7996C67.1223 73.7996 65.6001 72.2774 65.6001 70.3996V49.9996C65.6001 48.1219 67.1223 46.5996 69.0001 46.5996Z"
              fill="#0096D6"
            />
            <g filter="url(#filter0_d)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M69 39.8C53.9778 39.8 41.8 51.9778 41.8 67C41.8 82.0222 53.9778 94.2 69 94.2C84.0222 94.2 96.2 82.0222 96.2 67C96.2 51.9778 84.0222 39.8 69 39.8ZM35 67C35 48.2223 50.2223 33 69 33C87.7775 33 103 48.2223 103 67C103 85.7775 87.7775 101 69 101C50.2223 101 35 85.7775 35 67Z"
                fill="#0096D6"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x={0}
                y={0}
                width={138}
                height={138}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy={2} />
                <feGaussianBlur stdDeviation="17.5" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.305882 0 0 0 0 0.588235 0 0 0 0 0.792157 0 0 0 0.3 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </figure>
        <p>
          {intl.formatMessage({
            id: textId || 'undefined',
          })}
        </p>
        {isTextSmall && (
          <p style={{ fontSize: 'small' }}>
            {intl.formatMessage({
              id: textIdSmall || 'undefined',
            })}
          </p>
        )}
        <div className="alert-btn">
          <a
            href={hash}
            onClick={() =>
              params.commentId
                ? this.props.confirm(params.commentId)
                : this.props.confirm()
            }
          >
            {intl.formatMessage({
              id: 'yes',
            })}
          </a>
          <a href={hash} onClick={() => this.props.notConfirm()}>
            {intl.formatMessage({
              id: 'no',
            })}
          </a>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const obj = {}

  return obj
}

const mapDispatchToProps = {}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainVersionsAlerts))
)
